export const BREAKPOINT_XS = '500px';
export const BREAKPOINT_SM = '720px';
export const BREAKPOINT_MD = '1024px';
export const BREAKPOINT_LG = '1280px';
export const BREAKPOINT_XL = '1600px';
